import React from 'react'
import Logo from '@assets/images/logo.png'
import FormLogin from './components/FormLogin'
import './styles.scss'

const Login: React.FC = () => {

    return(

        <>
            <div id="formLoginContainer">
                <div className="loginContent">
                    <div className="loginGradient">
                        <img src={Logo} alt="" />
                    </div>
                </div>
                <div className="loginContent">
                    <FormLogin />
                </div>
            </div>
        </>

    )

}

export default Login